import script from "./SlideInDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideInDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SlideInDrawer.vue?vue&type=style&index=0&id=08f96fdc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f96fdc"]])

export default __exports__